import React from 'react';
import None from 'assets/Icons/Common/None';
import BasicButton from 'components/Buttons/BasicButton';
import { diagnosisNothingLists } from 'constants/diagnosisListPageConstants';
import {
    clFavoritePatientsNothingLists,
    clManagingPatientsNothingLists,
    clUserLookupNothingLists,
    managingPatientsDiagnosisNothingLists,
    managingPatientsDiagnosisNothingSearchLists,
} from 'constants/managingPatientsPageConstants';
import { mindupAdminMobilePaths, pagePaths } from 'constants/path';
import { todayDiagnosisNothingLists } from 'constants/todayDiagnosisConstants';
import { viewDetailPatientNothingLists } from 'constants/viewDetailPatientPageConstants';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useLoginStore } from 'store/useLoginDataStore';
import { AccountLevel } from 'utils/statusCode';
import { consultationNothingLists } from '../../../DCK/TodayDiagnosisPage/constants';
import IconArrowLineRight from 'assets/Icons/Arrow/Icon_arrowLine_right';
import { Body2Medium, Body5Regular } from 'styles/Global/typography';
import { TextColor } from 'styles/Global/colorSemantic';

const NothingDataInPagination = ({ initNumber, handleResetButton }: { initNumber?: number; handleResetButton?: () => void }) => {
    const { loginData } = useLoginStore();
    const navigate = useNavigate();

    return (
        <NothingDataWrapper>
            <None />
            <Text>{initNumber === 0 || !initNumber ? todayDiagnosisNothingLists.text : diagnosisNothingLists.text}</Text>
            <SubText>{initNumber === 0 || !initNumber ? todayDiagnosisNothingLists.subText : diagnosisNothingLists.subText}</SubText>

            {loginData.level !== AccountLevel.externalCounselor && (
                <BasicButton $width='200px' $height='44px' $type='fill' onClick={!initNumber || initNumber === 0 ? () => navigate(pagePaths.addDiagnosis) : handleResetButton}>
                    {initNumber === 0 || !initNumber ? todayDiagnosisNothingLists.buttonText : diagnosisNothingLists.buttonText}
                </BasicButton>
            )}
        </NothingDataWrapper>
    );
};

export default NothingDataInPagination;

export const NothingDataMindUpAdminPageInPagination = ({ initNumber, handleResetButton }: { initNumber?: number; handleResetButton?: () => void }) => {
    return (
        <NothingDataWrapper>
            <None />
            <Text>{consultationNothingLists.text}</Text>
        </NothingDataWrapper>
    );
};

export const NothingDataPatientDiagnosis = () => {
    return (
        <NothingDataWrapper>
            <None />
            <Text>{viewDetailPatientNothingLists.text}</Text>
            <SubText>{viewDetailPatientNothingLists.subText}</SubText>
        </NothingDataWrapper>
    );
};

export const NothingDataInManagingPatientsPagination = ({ initNumber, handleResetButton, type = 'managingPatients' }: { initNumber?: number; handleResetButton: () => void; type?: string }) => {
    const navigate = useNavigate();

    let textObj: { text: string; subText: string; buttonText: string } = { text: '', subText: '', buttonText: '' };
    let isButtonExist = true;
    switch (type) {
        case 'clManagingPatients':
            textObj = clManagingPatientsNothingLists;
            isButtonExist = false;
            break;
        case 'clFavoritePatients':
            textObj = clFavoritePatientsNothingLists;
            isButtonExist = false;
            break;
        case 'clUserLookup':
            textObj = clUserLookupNothingLists;
            isButtonExist = false;
            break;
        default:
            textObj = managingPatientsDiagnosisNothingLists;
            isButtonExist = true;
    }

    return (
        <NothingDataWrapper>
            <None />
            <Text>{initNumber === 0 || !initNumber ? textObj.text : textObj.text}</Text>
            <SubText>{initNumber === 0 || !initNumber ? textObj.subText : textObj.subText}</SubText>
            {isButtonExist && (
                <BasicButton $width='200px' $height='44px' $type='fill' onClick={initNumber === 0 ? () => navigate(pagePaths.addDiagnosis) : handleResetButton}>
                    {initNumber === 0 || !initNumber ? textObj.buttonText : managingPatientsDiagnosisNothingSearchLists.buttonText}
                </BasicButton>
            )}
        </NothingDataWrapper>
    );
};

export const NothingDataInMindUpAdminMobileUserReservationConsultationPage = () => {
    const navigate = useNavigate();

    return (
        <MindUpAdminLayout>
            <None />
            <Text>예약된 상담이 없습니다.</Text>
            <SubText>대기중인 상담 일시를 확정하고 시작해보세요!</SubText>
            <BasicButton $width='200px' $height='44px' $type='fill' onClick={() => navigate(mindupAdminMobilePaths.mindUpAdminMobileAllReservationConsultation)} $radius='99px'>
                예약 대기 상담보기 <IconArrowLineRight />
            </BasicButton>
        </MindUpAdminLayout>
    );
};
export const NothingDataInMindUpAdminMobileCompletedUserCounselPage = () => {
    const navigate = useNavigate();

    return (
        <MindUpAdminLayout $headerHeight='96px'>
            <None />
            <Text>완료된 상담이 없습니다.</Text>
            <SubText>예약된 상담 진행 후, 완료 처리해주세요!</SubText>
            <BasicButton $width='200px' $height='44px' $type='fill' onClick={() => navigate(mindupAdminMobilePaths.mindUpAdminMobileUserReservationConsultation)} $radius='99px'>
                상담 완료하러 가기 <IconArrowLineRight />
            </BasicButton>
        </MindUpAdminLayout>
    );
};

export const NothingDataInMindUpAdminMobileAllReservationConsultationPage = () => {
    return (
        <MindUpAdminLayout $marginTop='0' $headerHeight='96px'>
            <None />
            <Text>표시할 상담이 없습니다.</Text>
            <SubText>새로운 상담을 기다려주세요!</SubText>
        </MindUpAdminLayout>
    );
};

export const NothingDataInMindUpAdminMobileCompletedNoShow = () => {
    return (
        <MindUpAdminLayout $marginTop='0'>
            <None />
            <Text>노쇼로 종료된 상담이 없습니다.</Text>
            <SubText>상담을 노쇼로 2번 처리하시면, 종료됩니다.</SubText>
        </MindUpAdminLayout>
    );
};

const MindUpAdminLayout = styled.section<{ $marginTop?: string; $headerHeight?: string }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: ${(props) => `calc(100vh - ${props.$headerHeight || '56px'})`};
    margin-top: ${({ $marginTop }) => $marginTop || '-56px'};
`;

const NothingDataWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 360px;
`;

const SubText = styled(Body5Regular)`
    color: ${TextColor.color_text_weak};
    margin-bottom: 20px;
`;

const Text = styled(Body2Medium)`
    color: ${TextColor.color_text_light};
`;
